import { IconBox } from '@tabler/icons-react'

const NoDataFound = ({
  title = 'No Data Found',
  subtitle,
  icon = (
    <IconBox
      className="text-Icon-placeholder"
      stroke={2}
      data-testid="no-data-found-default-icon"
    />
  ),
  bgCSS = 'bg-BG-Default-white',
  compact = false,
  ...props
}) => {
  return (
    <div
      className={
        compact
          ? `flex w-full min-h-0 flex-col items-center justify-center mx-auto ${bgCSS} px-2 py-1 rounded-md`
          : `min-w-60 w-[70%] min-h-[131px] flex flex-col items-center justify-center mx-auto ${bgCSS} p-6 rounded-md`
      }
      data-testid="no-data-found-container"
      {...props}
    >
      <div
        className={`${
          compact ? 'mb-2 h-10 w-10' : 'mb-4 h-14 w-14'
        } flex shrink-0 flex-col items-center justify-center rounded-full bg-BG-Default-neutral-00`}
        data-testid="no-data-found-icon-container"
      >
        {icon}
      </div>
      <div
        className={`flex w-full flex-col items-center ${compact ? 'space-y-1' : 'space-y-2'}`}
        data-testid="no-data-found-content"
      >
        <h4
          className={`text-center font-bold text-Text-large-08 ${compact ? 'text-sm' : 'text-xl'}`}
          data-testid="no-data-found-title"
        >
          {title}
        </h4>
        {typeof subtitle === 'string' ? (
          <p
            className={`text-center text-Text-small-04 ${compact ? 'text-xs' : 'text-sm'}`}
            data-testid="no-data-found-subtitle"
          >
            {subtitle}
          </p>
        ) : (
          subtitle
        )}
      </div>
    </div>
  )
}

export default NoDataFound
